module.exports = __webpack_public_path__ + "img/desktop-error-404.3662d47f.svg";